@if (folder) {
  <div class="search-view-folder-header__title">
    @if (searchContainer.searchResult && searchContainer.objectCount && (searchContainer.objectCount - searchContainer.searchResult.search_count) !== 0) {
      <span class="alert-count">
        <span>
          {{'TRANS__FOLDER__VIEW__OBJECT_ACCESS' | translate:'{count: searchContainer.searchResult.search_count, objCount: searchContainer.objectCount}'}}
        </span>
      </span>
    }

    <div class="folder-description">
      <div class="folder-description__tabs" #container>
        @if ((196 * tabItems.length) > container.offsetWidth) {
          <div
            class="folder-description__scroll-button left-scroll"
            (click)="scrollTo('prev')"
            (keydown)="null"
            [ngClass]="{'scroll-button-disabled': scrollMenu.scrollLeft === 0}"
          >
            <mat-icon>
              chevron_left
            </mat-icon>
          </div>
        }

        <div
          class="folder-description__title" #scrollMenu
          [ngClass]="{'overflow': (196 * tabItems.length) > container.offsetWidth}"
        >
          @for (tabItem of tabItems; track $index) {
            <ng-container>
              <button
                mat-button (click)="toggleOpen(tabItem.object)"
                [style.max-width]="100 / tabItems.length + '%'"
                [title]="tabItem.header"
                [class.active-folder-header-tab]="tabItem.object.artifact_id === openedObject?.artifact_id"
              >
                <span>
                  {{tabItem.header}}
                </span>

                <mat-icon>
                  {{tabItem.object.artifact_id === openedObject?.artifact_id ? 'expand_less' : 'expand_more'}}
                </mat-icon>
              </button>
            </ng-container>
          }

        </div>

        @if ((196 * tabItems.length) > container.offsetWidth) {
          <div
            class="folder-description__scroll-button right-scroll"
            (click)="scrollTo('next')"
            (keydown)="null"
            [ngClass]="{'scroll-button-disabled': scrollMenu.scrollWidth - (scrollMenu.scrollLeft + container.offsetWidth) <= 0}"
          >
            <mat-icon>
              chevron_right
            </mat-icon>
          </div>
        }
      </div>

      @if (openedObject) {
        <hr>

        <div class="folder-description__container">
          <div class="folder-description__inner-container">
            <app-object-view-tabbed-sections
              [objectId]="openedObject.artifact_id"
              [folderId]="folder.artifact_id"
            ></app-object-view-tabbed-sections>
          </div>
        </div>
      }
    </div>
  </div>
}
